//网页信息

class cBase{
    constructor() {
        this.appSys = 0, //1=android 2=ios
        this.isWechat = false
    }
}
let baseInfo = new cBase()

function init() {
    var browser = {
        versions: function () {
            var u = navigator.userAgent, app = navigator.appVersion;
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
                iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }


    // alert(JSON.stringify(browser))
    if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        //如果是ios系统
        // alert("是ios系统")
        baseInfo.appSys = 2
    } else if (browser.versions.android) {
        //如果是Android系统 就
        // alert("是Android系统")
        baseInfo.appSys = 1
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // console.log('这是微信')
        // alert("这是微信")
        baseInfo.isWechat = true
    } else {
        // console.log('这是微信')
        // alert("不是微信")
        baseInfo.isWechat = false
    }
}

function getAppSys(){
    return baseInfo.appSys
}
function getIsWechat(){
    return baseInfo.isWechat
}

export const browser = {
    init,
    getAppSys,
    getIsWechat,
}
